// extracted by mini-css-extract-plugin
export default {"input":"InputForm_input__R6W1T","invalid":"InputForm_invalid__vu5Zb"};